import moment from "moment";
import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreatorV2 from "../../common/FormCreatorV2";

import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import { submitRegattaForms } from "../../redux/actions/regattaActions";

const SixWeekReview = ({ appData, submitRegattaFormsFunc }) => {
  const { firstName, lastName } = appData;

  const submitted = appData.regattaOnboarding && appData.regattaOnboarding.YRG6;

  const getVal = getField({});

  const initialState = {
    shiftType: {
      title: "Shift",
      value: getVal("shiftType"),
      type: "radio",
      radioOptions: ["A", "B", "Nights"],
    },
    startDate: {
      type: "date",
      title: "Start date",
      value: getVal("startDate"),
    },
    department: {
      title: "Department",
      value: getVal("department"),
    },
    trainer: {
      title: "Trainer",
      value: getVal("trainer"),
    },
    feelings: {
      title:
        "You've been working with us for 6 weeks - how are you feeling about the role?",
      value: getVal("feelings"),
    },
    confident: {
      title:
        "How confident are you to complete all tasks? Do you require more support from trainers and Team Leaders?",
      value: getVal("confident"),
    },
    feedback: {
      title:
        "Have you had any feedback during the last 6 weeks, if so what was it?",
      value: getVal("feedback"),
    },
    targets: {
      title:
        "Are you achieving the targets that were set? If not how much further do you have to go?",
      value: getVal("targets"),
    },
    concerns: {
      title: "Do you have any concerns that you would like to comment on?",
      value: getVal("concerns"),
    },
    comments: {
      title:
        "FLM/TL Comments: (Include how many absences, timekeeping, and any behavioural concerns)",
      value: getVal("comments"),
    },
    name: {
      title: "Name",
      value: `${firstName} ${lastName}`,
      type: "text",
      disabled: true,
    },
    signature: {
      title: "Signature",
      value: `${firstName} ${lastName}`,
      type: "text",
      disabled: true,
    },
    date: {
      title: "Date",
      value: moment(new Date()).format("DD/MM/YYYY"),
      type: "text",
      disabled: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const redirectBack = () => {
    history.push("/profile/edit/regatta-onboarding");
  };

  const submitForm = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    submitRegattaFormsFunc("SixWeekReview", { ...fieldValuesPayload }, "YRG6");
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"6 Week Agency Review"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"Regatta"}
          handleSubmit={submitForm}
          useSubmitText={true}
        />
      )}
    </>
  );
};

SixWeekReview.propTypes = {
  appData: any,
  submitRegattaFormsFunc: func.isRequired,
};

const mapDispatchToProps = {
  submitRegattaFormsFunc: submitRegattaForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(SixWeekReview);
